import React from "react";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const orderFormLabels = {
    'create-invoice': 'Create Order Form',
    'create-order-form': 'Create Order Form',
    invoices: 'Order Forms',
    'order-forms': 'Order Forms',
    'invoice-edit': 'Order Form Edit',
    'order-form-edit': 'Order Form Edit',
    'invoice-preview': 'Order Form Preview',
    'order-form-preview': 'Order Form Preview',
    'invoice-payments': 'Order Form Payments',
    'order-form-payments': 'Order Form Payments',
  };
  const orderFormLabel = orderFormLabels[pathnames[0]];
  const getPathLabel = (value, index) =>
    index === 0 && orderFormLabel ? orderFormLabel : value.replace(/-/g, ' ');
  const heading = orderFormLabel
    ? [orderFormLabel, ...pathnames.slice(1).map((value) => value.replace(/-/g, ' '))].join(' ')
    : (pathnames[pathnames.length - 1] || '').replace(/-/g, ' ');

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
      <h6 className="fw-semibold mb-0" style={{textTransform:'capitalize'}}>
        <p style={{ cursor: "pointer", display: "inline" }} onClick={() => window.history.back()}>
          <Icon  icon="solar:arrow-left-linear"/>
        </p>
         {heading}
      </h6>

      <ul className="d-flex align-items-center gap-2">
        <li className="fw-medium">
          <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
            Dashboard
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return (
            <React.Fragment key={to}>
              <li> - </li>
              <li className="fw-medium" style={{textTransform:'capitalize'}}>
                {isLast ? (
                  <span>{getPathLabel(value, index)}</span>
                ) : (
                  <Link to={to} className="hover-text-primary">
                    {getPathLabel(value, index)}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default Breadcrumb;
